import { useState, useEffect } from 'react'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: '15',
    seconds: '00',
  })

  useEffect(() => {
    // Start with 15 minutes (900 seconds)
    let totalSeconds = 15 * 60

    const timer = setInterval(() => {
      totalSeconds--

      // Reset to 15 minutes when it reaches 0
      if (totalSeconds < 0) {
        totalSeconds = 15 * 60
      }

      const m = Math.floor(totalSeconds / 60)
      const s = totalSeconds % 60

      setTimeLeft({
        minutes: m.toString().padStart(2, '0'),
        seconds: s.toString().padStart(2, '0'),
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return timeLeft
}
